import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import settingSlot from "./settingSlot";
import MaterialList from '@/components/material/list.vue';
import AppPageSelect from '@/components/app-page-select/IndexShop.vue';
import bgColorSelect from "../pages/page-components/bgColorSelect";
import draggable from "vuedraggable";
export default {
  components: {
    draggable: draggable,
    settingSlot: settingSlot,
    MaterialList: MaterialList,
    AppPageSelect: AppPageSelect,
    bgColorSelect: bgColorSelect
  },
  data: function data() {
    return {
      formDataCopy: {
        backgroundImg: '',
        height: 408,
        rowNum: 5,
        imageHeight: 180,
        pageSpacing: 0,
        imageItems: [{
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }]
      },
      formData: {
        backgroundImg: '',
        height: 408,
        rowNum: 10,
        imageHeight: 180,
        pageSpacing: 0,
        imageItems: [{
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }, {
          id: Math.random(),
          imageUrl: '',
          pageUrl: ''
        }]
      }
    };
  },
  props: {
    shopId: {
      type: String
    },
    thememobile: {
      type: Object | Array
    },
    clientType: [String],
    showData: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpage.componentsList;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpage.clickComIndex;
    }
  })),
  mounted: function mounted() {
    var that = this;
    if (that.IsEmptyObj(that.showData)) {
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
    } else {
      that.formData = that.showData;
    }
    that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
    // that.updateData({
    //   componentsList: that.componentsList
    // })
  },

  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    // 删除按钮
    delBtn: function delBtn(index) {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.componentsList[that.clickComIndex].data.itemArray, index);
        that.updateData({
          componentsList: that.componentsList
        });
      }).catch(function () {});
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    reset: function reset() {
      var that = this;
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
      that.componentsList[that.clickComIndex]['data'] = this.formData;
    },
    confirm: function confirm() {
      this.$emit('confirm', this.formData);
    },
    delete: function _delete() {
      this.$emit('delete');
    },
    // 更改每行个数
    rowNumChange: function rowNumChange() {
      if (this.formData.rowNum === 5) {
        if (this.formData.imageItems.length !== 5) {
          this.formData.imageItems.splice(5, 5);
        }
      } else {
        if (this.formData.imageItems.length !== 10) {
          for (var i = 0; i < 5; i++) {
            this.formData.imageItems.push({
              id: Math.random(),
              imageUrl: '',
              pageUrl: ''
            });
          }
        }
      }
    }
  }),
  watch: {
    shopId: function shopId() {},
    showData: {
      handler: function handler(newVal, oldVal) {
        this.formData = newVal ? newVal : this.formData;
      },
      deep: true
    },
    thememobile: function thememobile() {}
  }
};